import React from 'react';
import { useCollapsibleState } from '../FilterHelpers/useSRPFilters';
import { Collapsible, CollapsibleContent, CollapsibleHeader } from '../../../../../components/Collapsible';
import { FilterFuelType } from '../../Filter';
import { FilterFuelTypePropTypes } from '../../Filter/FilterFuelType';
import PropTypes from 'prop-types';

const CollapsibleFuelType = ({ facetConfig, label, handleDataChange, params, fuelTypes, selectedFuelTypes, tracking, position }) => {
  const { isEnabled, isOpen } = useCollapsibleState('fuelType', facetConfig);
  if (!isEnabled) {
    return null;
  }
  return (<CollapsibleContent
    initialState={isOpen}>
    <CollapsibleHeader priority={0}>
      {label}
    </CollapsibleHeader>
    <Collapsible>
      <FilterFuelType
        handleDataChange={handleDataChange}
        fuelTypes={fuelTypes}
        params={params}
        selectedFuelTypes={selectedFuelTypes}
        tracking={tracking}
        position={position}
      />
    </Collapsible>
  </CollapsibleContent>);
};

CollapsibleFuelType.propTypes = {
  ...FilterFuelTypePropTypes,
  facetConfig: PropTypes.array,
  label: PropTypes.string,
};

export { CollapsibleFuelType };
